import { Business as BusinessIcon } from "@mui/icons-material";
import {
  formatBuildingOptionLabel,
  formatBuildingOptionMeta
} from '@/utils/buildings';
import { useDispatch, useSelector } from "react-redux";
import { ListItemIcon, ListItemText, Tooltip, alpha } from "@mui/material";
import ListItemButton from '@mui/material/ListItemButton';
import { setIsSidebarOpen } from "@/features/layout/layoutSlice";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from "react-i18next";
import {
  openActiveBuildingSelect,
  selectActiveBuilding,
  selectAllBuildings,
} from "@/features/building/buildingSlice";
import useLayout from "@/features/layout/useLayout";


const VerticalMenuBuildingInfo = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isSidebarCollapsed } = useLayout(); 
  const activeBuilding = useSelector(selectActiveBuilding);
  const buildings = useSelector(selectAllBuildings);
  const canSwitchBuilding = buildings.length > 1;
  const buildingTitle = activeBuilding ? formatBuildingOptionLabel(activeBuilding) : '';
  const buildingSubtitle = activeBuilding ? formatBuildingOptionMeta(activeBuilding) : '';
  const handleSwitchBuilding = () => {
    if (!canSwitchBuilding) return
    dispatch(openActiveBuildingSelect());
    dispatch(setIsSidebarOpen(false));
  }
  if (!activeBuilding) return null;
  return (
    <Tooltip
      title={canSwitchBuilding ? t('choose_building') : ''}
      placement={isSidebarCollapsed ? 'top' : 'right'}
      disableHoverListener={!canSwitchBuilding}
    >
      <ListItemButton
        onClick={handleSwitchBuilding}
        disableGutters
        disableRipple={!canSwitchBuilding}
        tabIndex={canSwitchBuilding ? undefined : -1}
        sx={{
          border: '1px solid',
          borderColor: (theme) => (alpha(theme.palette.primary.main, 0.6)),
          // color: (theme) => (theme.palette.info.contrastText),
          borderRadius: 2,
          px: 1.25,
          py: 1.25,
          m: 0.5,
          marginRight: 'auto',
          mx: 0.5,
          width: 'auto',
          backgroundColor: (theme) => (alpha(theme.palette.primary.main, 0.05)),
          cursor: canSwitchBuilding ? 'pointer' : 'default',
          ...(canSwitchBuilding ? {
            '.rightIcon': {
              opacity: {
                md: 0.4,
              },
              transition: '.2s ease-in'
            },
            '&:hover .rightIcon': {
              opacity: 0.8,
            },
            '&:hover': {
              backgroundColor: (theme) => (alpha(theme.palette.primary.main, 0.15)),
            },
          } : {
            '&:hover': {
              backgroundColor: (theme) => (alpha(theme.palette.primary.main, 0.05)),
            },
          }),
          ...(isSidebarCollapsed ? {
            py: 0.5,
            mx: undefined,
            width: '100%',
          } : {})
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: isSidebarCollapsed ? 38 : 4,
            // px: 0.25,
          }}
        >
          <BusinessIcon />
        </ListItemIcon>
        {
          isSidebarCollapsed ? (
            <ListItemText
              slotProps={{
                primary: {
                  color: 'text.primary',
                  sx: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }
                },
                secondary: {
                  color: 'text.secondary',
                  sx: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }
                }
              }}
              primary={buildingTitle}
              secondary={buildingSubtitle}
              sx={{
                py: 0.5,
              }}  
            />
          ) : null
        }
        {
          isSidebarCollapsed && canSwitchBuilding ? (
            <ListItemIcon 
              className="rightIcon"
            >
              <ChevronRightIcon
                sx={{
                  ml: 'auto',
                }}
              />
            </ListItemIcon>
          ) : null
        }
      </ListItemButton>
    </Tooltip>
  );
}

export default VerticalMenuBuildingInfo;